module.exports = __webpack_public_path__ + "media/Whales.d8d540be.mp4";